module.exports = {
  title: 'Calendar Days Flip Animation',
  author: 'Enzo Manuel Mangano',
  date: '2025-12-01',
  slug: 'calendar-days',
  tags: ['reanimated'],
};
